<template>
  <section id="admin" class="w-full flex-1 max-w-5xl items-center mx-auto px-5 shadow-sm mb-20 pt-20">
    <Titre textePrincipal="Animaux de la seconde " texteAccentue="chance" :isSidebarOpen="isSidebarOpen" />
    <div class="container mx-auto p-4">
      <h1 class="text-2xl font-bold mb-4">Administration</h1>

      <!-- Loading pendant la vérification -->
      <div v-if="!adminAuth.verificationTerminee" class="mb-6 p-4 bg-blue-100 border border-blue-400 text-blue-700 rounded">
        🔄 Vérification des droits d'accès...
      </div>

      <!-- Formulaire de connexion si pas connecté ou pas admin -->
      <template v-else>
        <div v-if="!adminAuth.adminConnecte">
          <p class="mb-6">Bienvenue dans la section d'administration. Veuillez vous connecter pour continuer.</p>
          <LoginFormAdmin @login="handleLogin" />
        </div>

        <!-- Utilisateur connecté mais pas admin -->
        <div v-else-if="adminAuth.adminConnecte && !adminAuth.estAdmin" class="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
          <p>⚠️ Accès refusé. Vous devez avoir des droits administrateur pour accéder à cette section.</p>
          <button @click="handleLogout" class="bg-red-500 text-white px-4 py-2 rounded mt-4 hover:bg-red-600">
            Déconnexion
          </button>
        </div>

        <!-- Interface admin pour les utilisateurs autorisés -->
        <div v-else-if="adminAuth.adminConnecte && adminAuth.estAdmin">
          <button @click="handleLogout" class="bg-red-500 text-white px-4 py-2 rounded mb-4 hover:bg-red-600"
            aria-label="Déconnexion" title="Déconnexion de l'administrateur">
            Déconnexion
          </button>
          <p>Bienvenue {{ adminAuth.admin.displayName || adminAuth.admin.email?.split('@')[0] || 'Administrateur' }}, {{ adminAuth.admin.email }} ! Vous êtes connecté en tant qu'administrateur.</p>
          <ListeChatsAdmin />
        </div>
      </template>
    </div>
  </section>
</template>


// ...existing code...

<script setup>
import { useAdminAuth } from '../store/storeAdminAuth.js';
import Titre from '../composants/Titre.vue';
import LoginFormAdmin from '../composants/LoginFormAdmin.vue';
import ListeChatsAdmin from '../composants/ListeChatsAdmin.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';

import { auth } from '../firebase.js';
import { signOut, signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { onMounted, onBeforeUnmount } from 'vue';

const adminAuth = useAdminAuth();

// Fonction pour se connecter
async function handleLogin({ email, password }) {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    await adminAuth.connexionAdmin(userCredential.user);

    if (!adminAuth.estAdmin) {
      alert("Droits administrateur requis pour accéder à cette section.");
      await signOut(auth);
      adminAuth.deconnexionAdmin();
    }
  } catch (error) {
    console.error("Erreur de connexion:", error);
    alert("Erreur de connexion : " + error.message);
  }
}

// Fonction pour déconnexion
async function handleLogout() {
  try {
    await signOut(auth);
    adminAuth.deconnexionAdmin();
  } catch (error) {
    console.error("Erreur lors de la déconnexion:", error);
    alert("Erreur lors de la déconnexion : " + error.message);
  }
}

let unsubscribe = null;

onMounted(async () => {
  // NE PAS vérifier auth.currentUser ici car il peut être null temporairement
  // Laisser onAuthStateChanged gérer l'état initial
  
  // Écouter les changements d'authentification
  unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      console.log("Utilisateur détecté dans onAuthStateChanged:", user.email);
      await adminAuth.connexionAdmin(user);
    } else {
      console.log("Aucun utilisateur détecté dans onAuthStateChanged");
      adminAuth.deconnexionAdmin();
      // IMPORTANT : Marquer la vérification comme terminée quand on sait qu'il n'y a pas d'utilisateur
      adminAuth.verificationTerminee = true;
    }
  });

  window.addEventListener('beforeunload', autoLogout);
});

onBeforeUnmount(() => {
  if (unsubscribe) {
    unsubscribe();
  }
  window.removeEventListener('beforeunload', autoLogout);
});

async function autoLogout() {
  if (adminAuth.adminConnecte) {
    try {
      await signOut(auth);
      adminAuth.deconnexionAdmin();
    } catch (error) {
      console.error("Erreur lors de la déconnexion automatique :", error);
    }
  }
}
</script>